import isEqual from 'lodash/isEqual'
import { useEffect, useState } from 'react'
import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { ProtectedPage } from '~/features/common/Auth/protected-page'
import { MainLayout } from '~/widgets/common/layout/main'
import { MinimalLayout } from '~/widgets/common/layout/minimal'
import { CarPageAfrica } from './africa/Cars/EditCar/CarPage'
import { ListCarsPageAfrica } from './africa/Cars/ListCarsPage'
import { AddDriverPageAfrica } from './africa/Drivers/AddDriverPageAfrica'
import { DetailsPageAfrica } from './africa/Drivers/EditDriverPage'
import { AddCarRentalPageAfrica } from './africa/Organizations/CarRentals/AddCarRentalPageAfrica'
import { EditCarRentalPageAfrica } from './africa/Organizations/CarRentals/EditCarRentalPageAfrica'
import { ListCarRentalPageAfrica } from './africa/Organizations/CarRentals/ListCarRentalPageAfrica'
import NotFoundPage from './common/404'
import BalancePage from './common/Balance'
import AddCarPage from './common/Cars/AddCarPage'
import { CountryBasedComponent } from './common/CountryBasedComponent'
import Dashboards from './common/Dashboards/DashboardsPage'
import { DriverPage } from './common/Drivers/EditDriver'
import ListDriversPage from './common/Drivers/ListDriversPage'
import { usePermissionsPage } from './common/hooks/usePermissionsPage'
import { LoginPage } from './common/Login'
import { NoAccess } from './common/NoAccess'
import { OrganizationPage } from './common/Organizations'
import TaxiparkPage from './common/Taxipark'
import UserPersonalDataPage from './common/UserPersonalData'
import AddWorkRulePage from './common/WorkRules/AddWorkRulePage'
import DetailsWorkRulePage from './common/WorkRules/DetailsWorkRulePage'
import ListWorkRulesPage from './common/WorkRules/ListWorkRulesPage'
import { CarPageRussia } from './russia/Cars/EditCar/CarPage'
import { ListCarsPageRussia } from './russia/Cars/ListCarsPage'
import { AddDriverPageRussia } from './russia/Drivers/AddDriverPageRussia'
import { DetailsPageRussian } from './russia/Drivers/EditDriverPage'
import { AddCarRentalPageRussia } from './russia/Organizations/CarRentals/AddCarRentalPageRussia'
import { EditCarRentalPageRussia } from './russia/Organizations/CarRentals/EditCarRentalPageRussia'
import { ListCarRentalPageRussia } from './russia/Organizations/CarRentals/ListCarRentalPageRussia'

export const Routing: React.FC = () => {
  const location = useLocation()
  const { notPermissions } = usePermissionsPage()

  const [notPermissionsPage, setNotPermissionsPage] = useState(notPermissions)

  // Найти лучший способ для ререндера роутов
  useEffect(() => {
    if (!isEqual(notPermissions, notPermissionsPage)) {
      setNotPermissionsPage(notPermissions)
    }
    // eslint-disable-next-line
  }, [location])

  return (
    <Routes>
      <Route element={<ProtectedPage />}>
        <Route element={<MainLayout />}>
          {notPermissionsPage?.map((path) => (
            <Route key={path} path={path} element={<NoAccess />} />
          ))}

          <Route path='/' element={<Navigate to='/drivers' />} />

          <Route path='/drivers' element={<ListDriversPage />} />
          <Route
            path='/drivers/new'
            element={
              <CountryBasedComponent
                components={{
                  RU: AddDriverPageRussia,
                  CI: AddDriverPageAfrica,
                }}
              />
            }
          />
          <Route
            path='/drivers/:driverId/*'
            element={
              <DriverPage
                detailsPage={
                  <CountryBasedComponent
                    components={{
                      RU: DetailsPageRussian,
                      CI: DetailsPageAfrica,
                    }}
                  />
                }
              />
            }
          />

          <Route
            path='/cars'
            element={
              <CountryBasedComponent
                components={{
                  RU: ListCarsPageRussia,
                  CI: ListCarsPageAfrica,
                }}
              />
            }
          />
          <Route path='/cars/new' element={<AddCarPage />} />
          <Route
            path='/cars/:carId/*'
            element={
              <CountryBasedComponent
                components={{
                  RU: CarPageRussia,
                  CI: CarPageAfrica,
                }}
              />
            }
          />

          <Route path='/work-rules' element={<ListWorkRulesPage />} />
          <Route path='/work-rules/new' element={<AddWorkRulePage />} />
          <Route
            path='/work-rules/:workRuleId'
            element={<DetailsWorkRulePage />}
          />

          <Route
            path='/user-personal-data'
            element={<UserPersonalDataPage />}
          />
          <Route path='/taxipark/*' element={<TaxiparkPage />} />
          <Route
            path='/organizations/*'
            element={
              <OrganizationPage
                listCarRentalPage={
                  <CountryBasedComponent
                    components={{
                      RU: ListCarRentalPageRussia,
                      CI: ListCarRentalPageAfrica,
                    }}
                  />
                }
                addCarRentalPage={
                  <CountryBasedComponent
                    components={{
                      RU: AddCarRentalPageRussia,
                      CI: AddCarRentalPageAfrica,
                    }}
                  />
                }
                editCarRentalPage={
                  <CountryBasedComponent
                    components={{
                      RU: EditCarRentalPageRussia,
                      CI: EditCarRentalPageAfrica,
                    }}
                  />
                }
              />
            }
          />
          <Route path='/balance/*' element={<BalancePage />} />

          <Route path='/dashboards/*' element={<Dashboards />} />
        </Route>
      </Route>

      <Route element={<MinimalLayout />}>
        <Route path='/login' element={<LoginPage />} />
      </Route>

      <Route element={<MainLayout />}>
        <Route path='*' element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
